module.exports = __webpack_public_path__ + "img/1Q.1a4064db.jpg";